import { useContext, useEffect, useState } from 'react';

import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import { retrieveSession } from './services/auth.service';
import { SessionContext } from './context/session.context';
import { BackdropComponent } from './components/commons/backdrop/backdrop.component';
import { ProtectedRouteComponent } from './components/commons/protected-route/protected-route.component';
import { ROUTES } from './routes';
import { getUserByEmail } from './services/users.service';
import { getSummarize } from './services/summarize.service';
import { NavbarComponent } from './components/navbar/navbar.component';

export const AppComponent = () => {
  const { handleSession } = useContext(SessionContext);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getSession = async () => {
      const userObject = await retrieveSession();
      if (userObject && userObject.email) {
        const user = await getUserByEmail(userObject.email);
        await getSummarize(user.id);
        handleSession({
          userObject,
          user,
          logged: true
        });
      }
      setLoading(false);
    }
    getSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? (
    <BackdropComponent />
  ) : (
    <BrowserRouter>
      <SnackbarProvider maxSnack={3}>
        <NavbarComponent />
        <Switch>
          {ROUTES.map((route) =>
            route.policy ? (
              <ProtectedRouteComponent
                key={route.key}
                path={route.path}
                component={route.component}
                policy={route.policy}
                exact={route.exact}
              />
            ) : (
              <Route
                path={route.path}
                exact={route.exact}
                component={route.component}
                key={route.key}
              />
            )
          )}
        </Switch>
      </SnackbarProvider>
    </BrowserRouter>
  );
}
